import { invertRadians } from '@Utils/helpers/numericalHelpers';
import { styled } from '@mui/material';
import React from 'react';
import QcSymbology from '@Views/QualityControl/styles/symbology.scss';
import { ICircleObjectProps } from '../PlanView';
import { getCoordinatesOfPointOnCircle } from '../helpers';

interface ICameraIconProps {
    isSelected: boolean;
}

const CameraIcon = styled('svg', {
    shouldForwardProp: (prop) => prop !== 'isSelected',
})<ICameraIconProps>(
    ({ isSelected }) => ` 
        path {
            stroke:  ${isSelected ? 'black' : 'grey'};
            fill: ${isSelected ? `${QcSymbology.centerPole}` : 'transparent'};
            stroke-width: 2px;
            opacity: ${isSelected ? 0.5 : 0.35};
        }
`
);

interface ICameraPositionProps extends ICircleObjectProps {
    isSelected?: boolean;
}

export const CameraPosition = (props: ICameraPositionProps) => {
    const actualBearing = invertRadians(props.bearing);
    const position = getCoordinatesOfPointOnCircle(
        props.circleRadius - 20,
        actualBearing,
        {
            x: props.circleCenter - 12,
            y: props.circleCenter - 12,
        }
    );

    return (
        <CameraIcon x={position.x} y={position.y} isSelected={props.isSelected}>
            <path d="M9 2 7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z" />
        </CameraIcon>
    );
};
